import {gql} from '@apollo/client';

export const GENERATE_PARCEL_SHIPPING_LABEL_DOWNLOAD_REPORT = gql`
    mutation GenerateParcelShippingLabelDownloadReport($filters: OrderFiltersTypeInput, $timezone: String) {
        generateParcelShippingLabelDownloadReport(filters: $filters, timezone: $timezone)
    }
`;

export interface GenerateParcelShippingLabelDownloadReportResponse {
    generateParcelShippingLabelDownloadReport: string;
}

export interface GenerateParcelShippingLabelDownloadReportVariables {
    filters?: Record<string, unknown>;
    timezone?: string;
}
